module.exports = __webpack_public_path__ + "img/protocol.21cf4a6.svg";